<template>
  <div>
    <b-sidebar
      id="sidebar-add-new-event"
      sidebar-class="sidebar-lg sidebar-calendar-event-detail"
      :visible="isEventHandlerSidebarActive"
      bg-variant="white"
      shadow
      backdrop
      no-header
      right
      @change="(val) => $emit('update:is-event-handler-sidebar-active', val)"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <!-- <h5 class="mb-0">{{ eventLocal._id ? "Atualizar" : "Adicionar" }} Evento</h5> -->
          <h5 class="mb-0">Detalhes</h5>
          <div>
            <feather-icon
              v-if="eventLocal._id"
              icon="TrashIcon"
              class="cursor-pointer"
              @click="
                $emit('remove-event');
                hide();
              "
            />
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="hide"
            />
          </div>
        </div>
        
        <manage-news-view
          v-if="isEventHandlerSidebarActive && eventLocal"
          :class="{ show: isEventHandlerSidebarActive }"
          :newsViewData="eventLocal"
          @action-edit="$emit('action-edit', $event)"
          @action-copy="$emit('action-copy', $event)"
          @action-schedule="$emit('action-schedule', $event)"
          @action-publish="$emit('action-publish', $event)"
          @action-disable="$emit('action-disable', $event)"
          @action-cancel="$emit('action-cancel', $event)"
          @action-errata="$emit('action-errata', $event)"
        />
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BSidebar,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { required, email, url } from "@validations";
import { toRefs } from "@vue/composition-api";
import useCalendarEventDetail from "./useCalendarEventDetail";
import ManageNewsView from '@/views/pages/news/manage/ManageNewsView.vue';

export default {
  components: {
    BSidebar,
    ManageNewsView
  },
  directives: {
    Ripple,
  },
  created() {
  },
  model: {
    prop: "isEventHandlerSidebarActive",
    event: "update:is-event-handler-sidebar-active",
  },
  props: {
    isEventHandlerSidebarActive: {
      type: Boolean,
      required: true,
    },
    newsViewData: {
      type: Object,
    },
  },
  data() {
    return {
      required,
      email,
      url,
    };
  },
  setup(props, { emit }) {
    

    const {
      eventLocal,
      // UI
    } = useCalendarEventDetail(toRefs(props), emit);

    return {
      // Add New Event
      eventLocal,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
